import { XIcon } from 'lucide-react'
import { Campo, Entrada } from '@/components/ui/Campo'
import { cn } from '@/lib/cn'
import {
  DESTINOS,
  ETIQUETA_DESTINO,
  type DestinoPublicacion,
} from '@/lib/schemas/publicaciones'

/**
 * DEC-20 — la hora de publicación, opcional. El reloj del navegador ya
 * entiende "18:30" en todos lados (también en el iPhone); vacía es "sin
 * hora", y la cruz la vacía sin tener que borrar dígito por dígito.
 */
export function CampoHora({
  valor,
  error,
  alCambiar,
}: {
  valor: string
  error?: string | undefined
  alCambiar: (hora: string) => void
}) {
  return (
    <Campo etiqueta="Hora" ayuda="Opcional. Se puede completar después." error={error}>
      {(p) => (
        <div className="flex items-center gap-2">
          <Entrada
            id={p.id}
            type="time"
            aria-invalid={p.invalido}
            aria-describedby={p.describedBy}
            value={valor}
            onChange={(e) => {
              alCambiar(e.target.value)
            }}
            className="max-w-40"
          />
          {valor && (
            <button
              type="button"
              aria-label="Quitar la hora"
              onClick={() => {
                alCambiar('')
              }}
              className="flex size-9 items-center justify-center rounded-full text-tinta-suave hover:bg-lienzo"
            >
              <XIcon className="size-4" aria-hidden />
            </button>
          )}
        </div>
      )}
    </Campo>
  )
}

/** DEC-21 — dónde sale: en el feed o en historias. No es un tipo más. */
export function SelectorDestino({
  valor,
  alCambiar,
}: {
  valor: DestinoPublicacion
  alCambiar: (d: DestinoPublicacion) => void
}) {
  return (
    <fieldset>
      <legend className="mb-2 text-sm font-medium">Dónde sale</legend>
      <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Dónde sale">
        {DESTINOS.map((d) => (
          <button
            key={d}
            type="button"
            role="radio"
            aria-checked={valor === d}
            onClick={() => {
              alCambiar(d)
            }}
            className={cn(
              'min-h-11 rounded-full px-5 text-sm font-medium',
              valor === d
                ? 'bg-tinta text-white'
                : 'border border-borde bg-tarjeta text-tinta hover:bg-lienzo',
            )}
          >
            {ETIQUETA_DESTINO[d]}
          </button>
        ))}
      </div>
    </fieldset>
  )
}
